import { keywordGroupsQueryClient } from "app/services/keyword-groups";
import { TITLE_MAX_LENGTH } from "../KeywordGroupEditorHelpers";

const generateLastGroupVersion = (groups: Array<{ Name: string }>, groupName: string): number => {
    const lastGroupVersion = groups.reduce((last, group) => {
        if (new RegExp(`${groupName}[1-9]*`).test(group.Name)) {
            const currentVersionString = group.Name.slice(groupName.length);
            const currentVersion = currentVersionString ? +currentVersionString : 0;
            if (currentVersion > last) {
                return currentVersion;
            }
        }
        return last;
    }, -1);
    return lastGroupVersion;
};

export const getGroupName = async (seedKeyword: string): Promise<string> => {
    try {
        const userGroups = await keywordGroupsQueryClient.getUserGroups();
        const groupName = `${seedKeyword}`.slice(0, TITLE_MAX_LENGTH - 1);
        const lastGroupVersion = generateLastGroupVersion(userGroups, groupName);
        const listVersion = lastGroupVersion < 0 ? "" : lastGroupVersion + 1;
        const groupNameAndVersion = `${groupName} ${listVersion}`.trimEnd();
        return groupNameAndVersion;
    } catch {
        return seedKeyword.slice(0, TITLE_MAX_LENGTH - 1);
    }
};
